import React from 'react'
import { Divider, Steps } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import MassiveStepChanger from './MassiveStepChanger/MassiveStepChanger'
const { Step } = Steps

const MassiveCalculationSteps: React.FC = () => {
  const { t } = useTranslation()
  const { step } = useAppSelector((state) => state.admin.massiveCalculation)

  return (
    <>
      <Divider />
      <Steps current={step}>
        <Step title={t('admin.MassiveCalculate.UploadFile')} />
        <Step title={t('admin.MassiveCalculate.SelectFields')} />
        <Step title={t('admin.MassiveCalculate.ConfirmCalculus')} />
        <Step title={t('admin.MassiveCalculate.ExportResults')} />
      </Steps>
      <Divider />
      <MassiveStepChanger />
    </>
  )
}

export default MassiveCalculationSteps
